import React from 'react';
import { useForm } from '@formspree/react';
import { useTranslation } from 'react-i18next';
import './ContactForm.css';

const FORMSPREE_ENDPOINT = 'xyznabva';

const ContactForm = () => {
  const { t } = useTranslation();
  const [state, handleSubmit] = useForm(FORMSPREE_ENDPOINT);

  if (state.succeeded) {
    return (
      <div className="contact-form-wrapper">
        <div className="neon-success-box" style={{
          background: 'rgba(255, 140, 66, 0.1)',
          border: '2px solid #FF8C42',
          borderRadius: '12px',
          padding: 'var(--spacing-xl)',
          textAlign: 'center',
          boxShadow: '0 0 20px rgba(255, 140, 66, 0.3)'
        }}>
          <h3 style={{
            color: '#FF8C42',
            textShadow: '0 0 10px #FF8C42',
            marginBottom: 'var(--spacing-md)'
          }}>
            {t('contactForm.successTitle')}
          </h3>
          <p style={{
            color: 'var(--primary-white)',
            opacity: 0.9
          }}>
            {t('contactForm.successMessage')}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="contact-form-wrapper">
      <h3 className="form-title">{t('contactForm.title')}</h3>
      <p className="form-subtitle" style={{
        textAlign: 'center',
        marginTop: '-1rem',
        marginBottom: '2.9rem',
        fontSize: '1rem',
        lineHeight: 1.6,
        opacity: 0.9
      }}>
        {t('contactForm.subtitle')}
      </p>

      <form className="contact-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="name" className="form-label">{t('contactForm.nameLabel')}</label>
          <input
            type="text"
            id="name"
            name="name"
            required
            className="form-input"
            placeholder={t('contactForm.namePlaceholder')}
          />
        </div>

        <div className="form-group">
          <label htmlFor="email" className="form-label">{t('contactForm.emailLabel')}</label>
          <input
            type="email"
            id="email"
            name="_replyto"
            required
            className="form-input"
            placeholder={t('contactForm.emailPlaceholder')}
          />
        </div>

        <div className="form-group">
          <label className="form-label">{t('contactForm.topicsLabel')}</label>
          <div className="checkbox-grid">
            <label className="checkbox-item">
              <input type="checkbox" name="vfx-topic" value={t('contactForm.topicVfx')} />
              <span className="checkbox-label">{t('contactForm.topicVfx')}</span>
            </label>
            <label className="checkbox-item">
              <input type="checkbox" name="unreal-topic" value={t('contactForm.topicUnreal')} />
              <span className="checkbox-label">{t('contactForm.topicUnreal')}</span>
            </label>
            <label className="checkbox-item">
              <input type="checkbox" name="ai-topic" value={t('contactForm.topicAi')} />
              <span className="checkbox-label">{t('contactForm.topicAi')}</span>
            </label>
            <label className="checkbox-item">
              <input type="checkbox" name="web-topic" value={t('contactForm.topicWeb')} />
              <span className="checkbox-label">{t('contactForm.topicWeb')}</span>
            </label>
          </div>
        </div>

        <div className="form-group">
          <label htmlFor="message" className="form-label">{t('contactForm.messageLabel')}</label>
          <textarea
            id="message"
            name="message"
            required
            className="form-textarea"
            placeholder={t('contactForm.messagePlaceholder')}
            rows="5"
          />
        </div>

        <button
          type="submit"
          disabled={state.submitting}
          className={`btn form-submit-btn ${state.submitting ? 'submitting' : ''}`}
        >
          {state.submitting ? t('contactForm.submitting') : t('contactForm.submitButton')}
        </button>
      </form>
    </div>
  );
};

export default ContactForm;